import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "store";
import type { FridgeState } from "types";
import type { LocalFridgeSegment } from "../types/mainTypes";
import { getShortenedFridgeId } from "../utils/utils";

type FridgeInfoSlice = {
	id: string | null;
	segments: LocalFridgeSegment[];
	location: string | null;
	state: FridgeState | null;
};

const initialState: FridgeInfoSlice = {
	id: null,
	segments: [],
	location: null,
	state: null,
};

export const fridgeInfoSlice = createSlice({
	name: "fridgeInfo",
	initialState: initialState,
	reducers: {
		setFridgeId: (state, { payload }: PayloadAction<string>) => {
			state.id = payload;
		},
		setSegments: (state, { payload }: PayloadAction<LocalFridgeSegment[]>) => {
			state.segments = payload;
		},
		setLocation: (state, { payload }: PayloadAction<string>) => {
			state.location = payload;
		},
		setFridgeState: (state, { payload }: PayloadAction<FridgeState | null>) => {
			state.state = payload;
		},
	},
});

export const { setFridgeId, setSegments, setLocation, setFridgeState } = fridgeInfoSlice.actions;
export const selectFridgeId = (state: RootState) => state.fridgeInfo.id;

export const selectShortFridgeId = (state: RootState) => getShortenedFridgeId(state.fridgeInfo.id);
export const selectFridgeSegments = (state: RootState) => state.fridgeInfo.segments;
export const selectFridgeLocation = (state: RootState) => state.fridgeInfo.location;
export const selectFridgeState = (state: RootState) => state.fridgeInfo.state;

export default fridgeInfoSlice.reducer;
